export default __webpack_public_path__ + "static/media/app1-7.6c782819.jpg";